const MENU_ITEMS_ADMINISTRATION = [
  { key: "navigation", label: "Navigation", isTitle: true },
  {
    key: "lineup-dashboard",
    aliases: ["dashboard"],
    label: "Dashboard",
    isTitle: false,
    icon: "uil-analytics",
    url: "/dashboard",
    restricted: "dashboard.read",
  },

  {
    key: "Sales",
    label: "Sales",
    isTitle: true,
    restricted: "customerRequests.read",
  },
  {
    key: "customerRequests",
    aliases: ["requests", "request", "requestDetails", "offer"],
    label: "Requests",
    isTitle: false,
    icon: "mdi mdi-arrange-send-to-back",
    url: "/requests",
    restricted: "customerRequests.read",
    startPage: 1,
    standardSortBy: "createdAt",
    standardSortDirection: "desc",
    standardFilters: {
      status: ["0", "10", "20", "30"],
      createdAt: { from: null, to: null },
    },
  },
  {
    key: "orders",
    aliases: ["orders", "order"],
    label: "Orders",
    isTitle: false,
    icon: "uil-box",
    url: "/orders",
    restricted: "orders.read",
    startPage: 1,
    standardSortBy: "orderNumber",
    standardSortDirection: "desc",
    standardFilters: {
      customer: null,
      deliveryAddress: null,
      deliveryDate: { from: null, to: null },
      status: ["10", "20", "30", "40", "50", "55", "60"],
    },
  },
  {
    key: "goodsIssues",
    aliases: ["goodsIssues", "goodsIssue", "goodsIssueForm"],
    label: "Goods Issues",
    isTitle: false,
    icon: "mdi mdi-truck-outline",
    url: "/goodsIssues",
    restricted: "deliveries.read",
    startPage: 1,
    standardSortBy: "eta",
    standardSortDirection: "asc",
    standardFilters: {
      status: ["10", "50"],
    },
  },
  {
    key: "directDeliveries",
    aliases: ["directDeliveries", "directDelivery"],
    label: "Direct Deliveries",
    isTitle: false,
    icon: "mdi mdi-truck-outline",
    url: "/directDeliveries",
    restricted: "deliveries.read",
    startPage: 1,
    standardSortBy: "eta",
    standardSortDirection: "asc",
    standardFilters: {
      status: ["10", "50"],
    },
  },
  { key: "Purchase", label: "Purchase", isTitle: true },
  {
    key: "productRequests",
    aliases: ["productRequests", "productRequest"],
    label: "Product Requests",
    isTitle: false,
    icon: "mdi mdi-gamepad-circle-outline",
    url: "/productRequests",
    restricted: "productRequests.read",
    startPage: 1,
    standardSortBy: "createdAt",
    standardSortDirection: "desc",
    standardFilters: {
      status: ["10", "20", "25"],
      dueDate: { from: null, to: null },
      team: ["currentUser"],
    },
  },
  {
    key: "purchaseOrders",
    aliases: ["purchaseOrders", "purchaseOrder"],
    label: "Purchase Orders",
    isTitle: false,
    icon: "uil-receipt",
    url: "/purchaseOrders",
    restricted: "purchaseOrders.read",
    startPage: 1,
    standardSortBy: "purchaseOrderNumber",
    standardSortDirection: "asc",
    standardFilters: {
      status: ["10", "20", "30", "40", "50"],
    },
  },
  {
    key: "goodsReceipts",
    aliases: ["goodsReceipts", "goodsReceipt"],
    label: "Goods Receipts",
    isTitle: false,
    icon: "mdi mdi-truck-outline",
    url: "/goodsReceipts",
    restricted: "deliveries.read",
    startPage: 1,
    standardSortBy: "eta",
    standardSortDirection: "asc",
    standardFilters: {
      status: ["10", "50"],
    },
  },
  {
    key: "qualityReports",
    aliases: ["qualityReports", "qualityReport"],
    label: "Quality Reports",
    isTitle: false,
    icon: "mdi mdi-clipboard-edit-outline",
    url: "/qualityReports",
    restricted: "qualityReports.read",
    startPage: 1,
    standardSortBy: "createdAt",
    standardSortDirection: "asc",
    standardFilters: {
      status: ["20", "90", "100"],
    },
  },
  { key: "Import", label: "Import", isTitle: true },
  {
    key: "shipments",
    aliases: ["shipments", "shipment", "seaFreightRates"],
    label: "Seafreight",
    isTitle: false,
    icon: "uil-ship",
    url: "/shipments",
    restricted: "shipments.read",
    startPage: 1,
    standardSortBy: "positionNumber",
    standardSortDirection: "asc",
    standardFilters: {
      status: ["10", "11", "20", "50"],
      etd: { from: null, to: null },
      eta: { from: null, to: null },
    },
  },
  {
    key: "airFreights",
    aliases: ["airFreights", "airFreight"],
    label: "Air Freight",
    isTitle: false,
    icon: "uil-plane-fly",
    url: "/airFreights",
    restricted: "shipments.read",
    startPage: 1,
    standardSortBy: "positionNumber",
    standardSortDirection: "asc",
    standardFilters: {
      status: ["10", "50"],
      etd: { from: null, to: null },
      eta: { from: null, to: null },
    },
  },

  {
    key: "customs",
    aliases: ["customs"],
    label: "Customs",
    isTitle: false,
    icon: "uil-bill",
    url: "/customs",
    restricted: "customs.read",
    startPage: 1,
    standardSortBy: "positionNumber",
    standardSortDirection: "asc",
    standardFilters: {
      status: ["Requested", "Open"],
      releaseDate: { from: null, to: null },
    },
  },

  { key: "Administration", label: "Administration", isTitle: true },
  {
    key: "items",
    aliases: ["items", "item"],
    label: "Items",
    isTitle: false,
    icon: "mdi mdi-dots-hexagon",
    url: "/items",
    restricted: "items.read",
    standardSortBy: "createdAt",
    standardSortDirection: "asc",
    startPage: 1,
    standardFilters: {
      customer: null,
    },
  },
  {
    key: "customers",
    aliases: ["customers", "customer"],
    label: "Customers",
    isTitle: false,
    icon: "mdi mdi-account-edit-outline",
    url: "/customers",
    restricted: "customers.read",
    startPage: 1,
    standardSortBy: "number",
    standardSortDirection: "asc",
    standardFilters: {
      countryCode: null,
    },
  },
  {
    key: "suppliers",
    aliases: ["suppliers", "supplier"],
    label: "Suppliers",
    isTitle: false,
    icon: "mdi mdi-account-edit-outline",
    url: "/suppliers",
    restricted: "suppliers.read",
    startPage: 1,
    standardSortBy: "number",
    standardSortDirection: "asc",
    standardFilters: {
      countryCode: null,
    },
  },
];

const MENU_ITEMS_CUSTOMER = [
  { key: "navigation", label: "Navigation", isTitle: true },
  {
    key: "lineup-dashboard",
    aliases: ["dashboard"],
    label: "Dashboard",
    isTitle: false,
    icon: "uil-analytics",
    url: "/dashboard",
    restricted: "dashboard.read",
  },
  {
    key: "customerRequests",
    aliases: ["requests", "request", "requestDetails", "offer"],
    label: "Requests",
    isTitle: false,
    icon: "mdi mdi-arrange-send-to-back",
    url: "/requests",
    restricted: "customerRequests.read",
    startPage: 1,
    standardSortBy: "createdAt",
    standardSortDirection: "desc",
    standardFilters: {
      status: ["0", "10", "20", "30"],
      createdAt: { from: null, to: null },
    },
  },
  {
    key: "orders",
    aliases: ["orders", "order"],
    label: "Orders",
    isTitle: false,
    icon: "uil-box",
    url: "/orders",
    restricted: "orders.read",
    startPage: 1,
    standardSortBy: "orderNumber",
    standardSortDirection: "desc",
    standardFilters: {
      customer: null,
      deliveryAddress: null,
      deliveryDate: { from: null, to: null },
      status: ["10", "20", "30", "40", "50", "55", "60"],
    },
  },
  {
    key: "deliveries",
    aliases: ["deliveries", "delivery"],
    label: "Deliveries",
    isTitle: false,
    icon: "mdi mdi-truck-outline",
    url: "/deliveries",
    restricted: "deliveries.read",
    startPage: 1,
    standardSortBy: "eta",
    standardSortDirection: "asc",
    standardFilters: {
      status: ["10", "50"],
    },
  },
];

const MENU_ITEMS_SUPPLIER = [
  { key: "navigation", label: "Navigation", isTitle: true },
  {
    key: "lineup-dashboard",
    aliases: ["dashboard"],
    label: "Dashboard",
    isTitle: false,
    icon: "uil-analytics",
    url: "/dashboard",
    restricted: "dashboard.read",
  },
  { key: "Purchase", label: "Purchase", isTitle: true },
  {
    key: "productRequests",
    aliases: ["productRequests", "productRequest"],
    label: "Product Requests",
    isTitle: false,
    icon: "mdi mdi-arrange-send-to-back",
    url: "/productRequests",
    restricted: "productRequests.read",
    startPage: 1,
    standardSortBy: "createdAt",
    standardSortDirection: "desc",
    standardFilters: {
      status: ["10", "20", "25"],
      dueDate: { from: null, to: null },
      team: ["currentUser"],
    },
  },
  {
    key: "purchaseOrders",
    aliases: ["purchaseOrders", "purchaseOrder"],
    label: "Purchase Orders",
    isTitle: false,
    icon: "uil-receipt",
    url: "/purchaseOrders",
    restricted: "purchaseOrders.read",
    startPage: 1,
    standardSortBy: "purchaseOrderNumber",
    standardSortDirection: "asc",
    standardFilters: {
      status: ["10", "20", "30", "40", "50"],
    },
  },
];

export { MENU_ITEMS_ADMINISTRATION, MENU_ITEMS_CUSTOMER, MENU_ITEMS_SUPPLIER };
